"use client";
import { ErrorFallback } from "@/components/fallback/error-fallback";

export default ErrorFallback;
